module.exports = __webpack_public_path__ + "img/icon2@3x.6c0d72cc.png";